module.exports = __webpack_public_path__ + "public/img/yiai.e8cc3ec0.png";